export const extractRootDomain = (url: string): string => {
  return new URL(url).hostname;
};
